import { render, staticRenderFns } from "./RatesComponent.vue?vue&type=template&id=572f2174&"
import script from "./RatesComponent.vue?vue&type=script&lang=js&"
export * from "./RatesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports